import styled from 'styled-components';
import { rem } from 'polished';
var Description = styled.div.withConfig({
  displayName: "Description",
  componentId: "ve119j-0"
})(["margin-bottom:", ";"], rem(24));
export default Description;